import React from 'react';
import { SnackbarProvider } from 'notistack';
import { ErrorBox } from '@gorilla/ui/src/components/ErrorBox';
import Editor from './components/Editor';
import { WidgetList } from './components/WidgetList';
import { useWidgets } from './hooks/use-widgets';

class ErrorBoundary extends React.Component<{ children: React.ReactNode }> {
  state = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return <ErrorBox error={this.state.error} />;
    }

    return this.props.children;
  }
}

function Widgets() {
  const { board, widgets, widgetsError, isBusy, selectedWidget, selectWidget, addWidget, duplicateWidget, renameWidget, removeWidget } =
    useWidgets();

  if (widgetsError) {
    return <ErrorBox error={widgetsError} />;
  }

  if (selectedWidget) {
    return (
      <Editor
        // remount the editor on widget switch so no per-widget state survives the change
        key={selectedWidget.id}
        widget={selectedWidget}
        onBackToList={() => selectWidget(null)}
      />
    );
  }

  return (
    <WidgetList
      widgets={widgets}
      boardName={board?.name}
      isBusy={isBusy}
      onOpen={(widget) => selectWidget(widget.id)}
      onCreate={addWidget}
      onDuplicate={duplicateWidget}
      onRename={renameWidget}
      onDelete={removeWidget}
    />
  );
}

function App() {
  return (
    <div>
      <ErrorBoundary>
        <SnackbarProvider>
          <Widgets />
        </SnackbarProvider>
      </ErrorBoundary>
    </div>
  );
}

export default App;
